import { GlobalStyles as MuiGlobalStyles, Theme } from '@mui/material';

export const GLOBAL_SCROLLBAR_WIDTH = 4;
export const GLOBAL_SCROLLBAR_HEIGHT = 4;

const scrollbarStyles = (theme: Theme) => ({
  '*': {
    '&::-webkit-scrollbar': { width: GLOBAL_SCROLLBAR_WIDTH, height: GLOBAL_SCROLLBAR_HEIGHT },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 999,
      backgroundColor: theme.palette.action.active,
    },
    '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
    '@media (hover: hover)': {
      '--scrollbar-thumb-color': 'transparent',
      '&:hover': { '--scrollbar-thumb-color': theme.palette.action.active },
      '&::-webkit-scrollbar-thumb': { backgroundColor: 'var(--scrollbar-thumb-color)' },
    },
    '@supports not selector(::-webkit-scrollbar)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `var(--scrollbar-thumb-color, ${theme.palette.action.active}) transparent`,
    },
  },
});

const boxSizing = {
  '*, *::before, *::after': {
    boxSizing: 'border-box',
  },
};

const IconStrokeWidth = {
  '.lucide, .custom-icon': {
    strokeWidth: 2,
  },
};

export default function V2GlobalStyles() {
  return (
    <MuiGlobalStyles
      styles={(theme) => ({
        ...boxSizing,
        ...scrollbarStyles(theme),
        ...IconStrokeWidth,
      })}
    />
  );
}
